import { render } from "./file_preview_component.html?vue&type=template&id=ea51a164&scoped=true&external"
import script from "./file_preview_component.js?vue&type=script&lang=js&external"
export * from "./file_preview_component.js?vue&type=script&lang=js&external"

import "./FilePreviewComponent.vue?vue&type=style&index=0&id=ea51a164&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea51a164"]])

export default __exports__